// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__lqDbj","content":"Hero_content__IYqkL","buttonContainer":"Hero_buttonContainer__zXFN0","btn":"Hero_btn__dUToe"};